'use strict';

// JSON Polyfill for unsupported older browser
if (!window.JSON) {
    window.JSON = {
        parse: function (sJSON) { // eslint-disable-line strict
            return eval('(' + sJSON + ')'); // eslint-disable-line no-eval
        },
        stringify: function stringify (vContent) { // eslint-disable-line strict
            if (vContent instanceof Object) {
                var sOutput = '';
                if (vContent.constructor === Array) {
                    // @TODO: Does this line of code work? for loops can have 4 arguments? huh?
                    for (var nId = 0; nId < vContent.length; sOutput += this.stringify(vContent[nId]) + ',', nId++); // eslint-disable-line curly,no-extra-semi
                    return '[' + sOutput.substr(0, sOutput.length - 1) + ']';
                }
                if (vContent.toString !== Object.prototype.toString) {
                    return '\"' + vContent.toString().replace(/"/g, '\\$&') + '\"';
                }
                for (var sProp in vContent) {
                    sOutput += '\"' + sProp.replace(/"/g, '\\$&') + '\":' + this.stringify(vContent[sProp]) + ',';
                }
                return '{' + sOutput.substr(0, sOutput.length - 1) + '}';
            }
            return typeof vContent === 'string' ? '\"' + vContent.replace(/"/g, '\\$&') + '\"' : String(vContent);
        }
    };
}

// Date.now polyfill
if (!Date.now) {
    Date.now = function() { // eslint-disable-line strict
        return new Date().getTime();
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/shim.js
 ** module id = 33
 ** module chunks = 0
 **/